import styled from 'styled-components';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { CloudImage } from '@components/CloudImage';

export const PhotoTextContainer = styled(Text)`
  max-width: 624px;
`;

export const StyledImageContainer = styled(CloudImage)<{ objectFit?: string }>`
  object-fit: cover;
  object-fit: ${props => (props.objectFit ? props.objectFit : 'cover')};
`;

export const StyledImageWrapper = styled(Box)<{ width: number; height: number }>`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  position: relative;
  border-radius: 8px;
  background-color: rgba(230, 182, 155, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
`;
